//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {ParseTime} from "../../utils/time"
import {Api} from "../../utils/api"
import {Fetch} from "../../utils/storage"
import NotFound from '../../components/NotFound'

export default {
    name: 'MemberUser-list',

    filters: {
        ParseEndAt(val) {
            return ParseTime(val, '{y}-{m}-{d}')
        }
    },
    data () {
        return {
            MemberUserList:[],
            Page: 1,
            Limit:999,
            SearchValue: '',
            IsShowNotFound:false,
        }
    },
    components: {
        NotFound
    },
    created () {
        this.FetchMemberUserList()
        this.UserID = Fetch("ID")
    },
    methods: {
        ParseTime,
        async FetchMemberUserList() {
            try {
                let reqData = {
                    Data:{
                    },
                    Limit:this.Limit,
                    Offset: (this.Page - 1) * this.Limit,
                    
                    Preloads:[
                        {Column:'Committee'},
                    ]

                }
                let res = await Api('GetMemberUserList', reqData)
                this.MemberUserList = (res.data && res.data.List) ? res.data.List : []
                if (this.MemberUserList.length <1) this.IsShowNotFound = true
            }catch(err){
                console.log(err)
            }
        },
        async handleDetailClick(id) {
            let _this = this
            let MemberUserID = id
            _this.$router.push(`/committee/member-user/detail/${MemberUserID}`)
        },
    }
}
